import * as React from "react";
const SvgFiRrCheapStack = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cheap-stack_svg__a)">
      <path
        fill="#062147"
        d="M6.5 1C3.27 1 0 2.202 0 4.5v16C0 22.798 3.27 24 6.5 24s6.5-1.202 6.5-3.5v-16C13 2.202 9.73 1 6.5 1M11 16.5c0 .436-1.577 1.5-4.5 1.5S2 16.936 2 16.5v-1.409c1.226.601 2.867.909 4.5.909s3.274-.308 4.5-.909zm0-4c0 .436-1.577 1.5-4.5 1.5S2 12.936 2 12.5v-1.409c1.226.601 2.867.909 4.5.909s3.274-.308 4.5-.909zm0-4c0 .436-1.577 1.5-4.5 1.5S2 8.936 2 8.5V7.091C3.226 7.692 4.867 8 6.5 8s3.274-.308 4.5-.909zM6.5 3C9.423 3 11 4.064 11 4.5S9.423 6 6.5 6 2 4.936 2 4.5 3.577 3 6.5 3m0 19C3.577 22 2 20.936 2 20.5v-1.409c1.226.601 2.867.909 4.5.909s3.274-.308 4.5-.909V20.5c0 .436-1.577 1.5-4.5 1.5m17.207-1.412-2.535 2.535A3 3 0 0 1 19.05 24a3 3 0 0 1-2.121-.876l-2.636-2.636a.999.999 0 1 1 1.414-1.414L18 21.367V1a1 1 0 1 1 2 0v20.467l2.293-2.293a.999.999 0 1 1 1.414 1.414"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cheap-stack_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCheapStack;
